import { i18n } from 'next-i18next';

const getTranslation = (key: string, ns: string, variables?: Record<string, string | number>) => {
  if (!i18n) {
    throw new Error('i18n is not initialized');
  }

  return i18n.t(`${ns}:${key}`, variables);
};

export default getTranslation;
